import React from 'react';
import { FiClock, FiShield, FiUsers, FiMessageSquare } from 'react-icons/fi';

const items = [
  {
    icon: <FiClock className="h-5 w-5" />,
    title: '24/7 availability',
    text: 'Request support any time through our service desk.',
  },
  {
    icon: <FiShield className="h-5 w-5" />,
    title: 'Secure handling',
    text: 'Your request details are processed through a protected flow.',
  },
  {
    icon: <FiUsers className="h-5 w-5" />,
    title: 'Partner-trained agents',
    text: 'Experienced teams handle subscription and billing questions.',
  },
  {
    icon: <FiMessageSquare className="h-5 w-5" />,
    title: 'Clear communication',
    text: 'Straightforward answers, quick follow-up, and guided next steps.',
  },
];

export default function TrustBar() {
  return (
    <section className="px-4 py-10 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-4">
          {items.map(item => (
            <div key={item.title} className="flex flex-col items-start gap-3 rounded-lg border p-4 bg-white shadow-sm">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-[var(--brand-accent)] text-white">{item.icon}</div>
              <h3 className="text-sm font-semibold text-[var(--brand-ink)]">{item.title}</h3>
              <p className="mt-1 text-sm text-[var(--text-muted)]">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}